module.exports = __webpack_public_path__ + "img/market-rider.21be467d.png";